// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-compensation-table .VueTables__row > td:nth-child(4), .view-compensation-table th:nth-child(4) {
  border-left: 2px solid #DFDFDF !important;
}
.view-compensation-table .VueTables__row > td:nth-child(7), .view-compensation-table th:nth-child(7) {
  border-left: 2px solid #DFDFDF !important;
}
.view-compensation-table .VueTables__row > td:nth-child(10), .view-compensation-table th:nth-child(10) {
  border-left: 2px solid #DFDFDF !important;
}
.view-compensation-table .VueTables__row > td:nth-child(12), .view-compensation-table th:nth-child(12) {
  border-right: 3px solid #DFDFDF !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
